import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import LeftArrowIconButton from 'LegacyWeployDesignLanguage/icons/LeftArrowIconButton';
import FullScreenDialog from './FullScreenDialog';
import JobPostingOptions from './JobTypeOptions';
import JobTemplateOptions from './JobTemplateOptions';

const StyledLeftArrowIcon = styled(LeftArrowIconButton)`
  position: absolute;
  top: ${props => props.theme.spacing};
`;

const { Title, Content } = FullScreenDialog;

export const JOB_TYPES = {
  DIRECT: 'Direct',
  SELECT: 'Select',
  REHIRE: 'Rehire',
};

const JobTypeSelectionModal = ({ open, onJobPostingStrategyModalClose }) => {
  const [jobPostingOptionsVisible, setJobPostingOptionsVisible] = useState(true);
  const [selectedJobType, setSelectedJobType] = useState(null);

  const handleContinueClick = (jobType) => {
    setSelectedJobType(jobType);
    setJobPostingOptionsVisible(false);
  };

  const handleBackButtonClick = () => (
    setJobPostingOptionsVisible(true)
  );

  const handleDialogClose = () => {
    onJobPostingStrategyModalClose();
  };

  return (
    <FullScreenDialog
      open={open}
      onClose={handleDialogClose}
    >
      <Title onClose={handleDialogClose}>
        <div>
          {!jobPostingOptionsVisible && <StyledLeftArrowIcon size="large" onClick={handleBackButtonClick} />}
        </div>
      </Title>
      <Content>
        {
          jobPostingOptionsVisible
            ? <JobPostingOptions onContinueClick={handleContinueClick} />
            : <JobTemplateOptions jobType={selectedJobType} />
        }
      </Content>
    </FullScreenDialog>
  );
};

JobTypeSelectionModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onJobPostingStrategyModalClose: PropTypes.func.isRequired,
};

export default JobTypeSelectionModal;

